// extracted by mini-css-extract-plugin
module.exports = {"option":"Controller_option__3t9tD","labelWrapper":"Controller_labelWrapper__2Hk4-"};